import Commission from './Commission'

export default Commission